<div class="audit-dialog">

    <div class="audit-head">
        <div class="audit-head-text">
            <h2 class="audit-title">Audit log</h2>
            <p class="audit-sub">
                {{ data.referenceNo }} · {{ data.submitter }} · immutable record of submissions and status changes.
            </p>
        </div>
        <button type="button" class="audit-close" aria-label="Close audit log" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="audit-body">
        @if (data.entries.length) {
        @for (entry of data.entries; track $index) {
        <div class="audit-row">
            <div class="audit-time">{{ entry.at | date:'dd MMM · HH:mm':'+0800' }}</div>
            <div class="audit-dot" [class]="'audit-dot ' + entry.tone"></div>
            <div class="audit-detail">
                <div class="audit-action">{{ entry.action }}</div>
                <div class="audit-note">{{ entry.detail }}</div>
            </div>
            <div class="audit-actor">{{ entry.actor }}</div>
        </div>
        }
        } @else {
        <p class="audit-empty">Nothing has been recorded against this advertisement yet.</p>
        }
    </div>
</div>
